import React, { FunctionComponent, useEffect, useState } from 'react'
import { Checkbox, Divider, Grid } from '@material-ui/core'
import * as Yup from 'yup'
import { useFrotista } from 'modules/user/hooks/useFrotista'
import { Subtitle, Title, Text } from '../styles'
import Form from 'shared/components/Form'
import Input from 'shared/components/Input'
import { Termos } from './styles'
import ModalTermos from './components/ModalTermos'
import { NumericFormat } from 'react-number-format'
import { colors } from 'shared/styles/colors'
import Footer from '../components/Footer'
import { ITermosOnboarding } from 'modules/pagamentos/domain/usecases/TermosOnboarding'
import LoadingBackdrop from 'shared/components/LoadingBackdrop'
import DadosControladora from './components/DadosControladora'
import { useOnboarding } from 'modules/pagamentos/hooks/useOnboarding'
import SnackBar from 'shared/components/SnackBar'
import ETipoDocumentoOnboarding from 'modules/pagamentos/domain/entities/ETipoDocumentoOnboarding'
import ENaturezaJuridica from 'modules/pagamentos/domain/entities/ENaturezaJuridica'
import getValidationErrors, {
  IValidationErrors,
} from 'shared/utils/getValidationErrors'
import ETipoTermosAceiteOnboarding from 'modules/pagamentos/domain/entities/ETipoTermosAceiteOnboarding'
import Modal from 'shared/components/Modal'

interface DadosGeraisProps {
  termosAceiteOnboarding: ITermosOnboarding
}

interface IFormProps {
  receitaAnual: string
}

const DadosGerais: FunctionComponent<DadosGeraisProps> = ({
  termosAceiteOnboarding,
}) => {
  const { frotista, frotistaId } = useFrotista()
  const {
    handleNextButton,
    handleBackButton,
    naturezaJuridicaEmpresaControlada,
    setContaPj,
    contaPj,
    empresaControlada,
    setEmpresaControlada,
    getDocumentoEmpresaControladoraNome,
  } = useOnboarding()
  const [loading, setLoading] = useState(false)
  const [receitaAnual, setReceitaAnual] = useState<number>(
    () => contaPj?.receita_anual ?? null,
  )
  const [termosDeUso, setTermosDeUso] = useState('')
  const [openModalTermosDeUso, setOpenModalTermosDeUso] = useState(false)
  const [termosPrivacidade, setTermosPrivacidade] = useState('')
  const [openModalTermosDePrivacidade, setOpenModalTermosDePrivacidade] =
    useState(false)
  const [aceiteTermosDeUso, setAceiteTermosDeUso] = useState(false)
  const [isOk, setIsOk] = useState(false)
  const [errorMessageForm, setErrorMessageForm] = useState({} as IFormProps)
  const [errorMessage, setErrorMessage] = useState('')
  const [openErrorMessage, setOpenErrorMessage] = useState(false)
  const [openModalAdBlock, setOpenModalAdBlock] = useState(false)

  useEffect(() => {
    const carregarTermos = async () => {
      try {
        setLoading(true)
        const responseTermos = await termosAceiteOnboarding.execute({
          frotista_id: frotistaId,
          tipo: ETipoTermosAceiteOnboarding.TERMOS_DE_USO,
        })
        if (responseTermos) setTermosDeUso(responseTermos.texto)
        const responsePrivacidade = await termosAceiteOnboarding.execute({
          frotista_id: frotistaId,
          tipo: ETipoTermosAceiteOnboarding.TERMOS_DE_PRIVACIDADE,
        })
        if (responsePrivacidade) setTermosPrivacidade(responsePrivacidade.texto)
      } catch (error: unknown) {
        if (error instanceof Error) {
          setErrorMessage(error.message)
        } else {
          setErrorMessage('Erro ao buscar termos')
        }
      } finally {
        setLoading(false)
      }
    }
    carregarTermos()
  }, [])

  const showValidationErrors = (errors: IValidationErrors) => {
    setErrorMessageForm({
      receitaAnual: errors.receitaAnual,
    })
  }

  const handleSubmit = async () => {
    if (empresaControlada) {
      switch (naturezaJuridicaEmpresaControlada) {
        case ENaturezaJuridica.LTDA:
          if (
            !getDocumentoEmpresaControladoraNome(
              ETipoDocumentoOnboarding.ESTATUTO_SOCIAL,
            )
          ) {
            setErrorMessage('Anexar Estatuto')
            setOpenErrorMessage(true)
          }
          return
        case ENaturezaJuridica.SA:
          if (
            !getDocumentoEmpresaControladoraNome(
              ETipoDocumentoOnboarding.ESTATUTO_SOCIAL,
            )
          ) {
            setErrorMessage('Anexar Estatuto')
            setOpenErrorMessage(true)
          }
          return
        case ENaturezaJuridica.FundoDeInvestimento:
          if (
            !getDocumentoEmpresaControladoraNome(
              ETipoDocumentoOnboarding.ESTATUTO_SOCIAL,
            )
          ) {
            setErrorMessage('Anexar Estatuto')
            setOpenErrorMessage(true)
          }
          return

        default:
          return
      }
    }

    setErrorMessage('')
    setOpenErrorMessage(false)
    try {
      const schema = Yup.object().shape({
        receitaAnual: Yup.number().required('Receita anual inválida!'),
      })
      await schema.validate(
        {
          receitaAnual,
        },
        {
          abortEarly: false,
        },
      )

      setContaPj({
        ...contaPj,
        receita_anual: receitaAnual,
        responsaveis: {
          pessoas_fisicas: contaPj?.responsaveis?.pessoas_fisicas
            ? [...contaPj?.responsaveis?.pessoas_fisicas]
            : [],
          pessoas_juridicas: [
            {
              cnpj: frotista.cnpj,
              razao_social: frotista.razao_social,
            },
          ],
        },
      })
      handleNextButton()
    } catch (error: any) {
      if (error instanceof Yup.ValidationError) {
        const errors = getValidationErrors(error)
        showValidationErrors(errors)
      } else if (error instanceof Error) {
        setErrorMessage(error.message)
        setOpenErrorMessage(true)
      }
    }
  }

  const handleModalTermosDeUso = () => {
    setOpenModalTermosDeUso(!openModalTermosDeUso)
  }

  const handleModalTermosDePrivacidade = () => {
    setOpenModalTermosDePrivacidade(!openModalTermosDePrivacidade)
  }

  const handleOnBlur = (field: string, value: any): void => {
    if (!value) {
      setErrorMessageForm(errors => ({
        ...errors,
        [field]: 'Campo obrigatório',
      }))
    } else {
      setErrorMessageForm(errors => ({
        ...errors,
        [field]: '',
      }))
    }
  }

  return (
    <>
      {loading && <LoadingBackdrop open={loading} color={colors.green} />}
      <Divider style={{ margin: '32px 0' }} />
      <Grid container>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <Title>Dados da empresa</Title>
          <Subtitle>
            Informe os dados da empresa e os contatos empresariais.
          </Subtitle>
        </Grid>
        <Form
          onSubmit={handleSubmit}
          initialValues={{
            receitaAnual,
          }}
          validationSchema={() => ({
            receitaAnual: Yup.number().required('Receita anual inválida!'),
          })}
        >
          {formControl => (
            <Grid container>
              <Grid container style={{ margin: '8px 0' }}>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={3}
                  lg={3}
                  style={{ marginRight: 32 }}
                >
                  <Input name="cnpj" value={frotista?.cnpj} disabled />
                </Grid>
                <Grid item xs={12} sm={12} md={5} lg={5}>
                  <Input
                    name="razaoSocial"
                    value={frotista?.razao_social}
                    disabled
                  />
                </Grid>
              </Grid>
              <Grid container style={{ margin: '8px 0' }}>
                <Grid item xs={12} sm={12} md={5} lg={5}>
                  <NumericFormat
                    placeholder="Receita anual*"
                    name="receitaAnual"
                    customInput={Input}
                    thousandSeparator="."
                    decimalSeparator=","
                    decimalScale={2}
                    fixedDecimalScale={true}
                    prefix="R$ "
                    allowLeadingZeros={true}
                    required
                    value={receitaAnual}
                    onValueChange={values => {
                      formControl.setFieldValue(
                        'receitaAnual',
                        values.floatValue,
                      )
                      setReceitaAnual(values.floatValue)
                      setContaPj({
                        ...contaPj,
                        receita_anual: values.floatValue,
                      })
                    }}
                    onBlur={() => {
                      formControl.setFieldTouched('receitaAnual', true)
                      handleOnBlur(
                        'receitaAnual',
                        formControl.values.receitaAnual,
                      )
                    }}
                    errorMessage={errorMessageForm.receitaAnual}
                  />
                </Grid>
              </Grid>
              {/* AGUARDANDO DEFINIÇÃO DA DOCK
                <Grid container alignItems="center">
                <Checkbox
                  style={{ color: colors.green }}
                  checked={empresaControlada}
                  onChange={() => setEmpresaControlada(!empresaControlada)}
                />
                <Text>Empresa controlada por outras empresas</Text>
              </Grid> */}
            </Grid>
          )}
        </Form>
      </Grid>
      <Divider style={{ margin: '32px 0' }} />

      {empresaControlada && <DadosControladora />}
      <Grid container>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <Title>Termos de Uso</Title>
          <Subtitle>
            Antes de concordar, clique no link e leia os{' '}
            <Termos onClick={handleModalTermosDeUso}>Termos de Uso</Termos> e
            <Termos onClick={handleModalTermosDePrivacidade}>
              Termos de Privacidade
            </Termos>
          </Subtitle>
        </Grid>
        <Grid>
          <Form
            onSubmit={handleSubmit}
            initialValues={{
              aceiteTermosDeUso: false,
            }}
            validationSchema={() => ({
              aceiteTermosDeUso: Yup.boolean().required(),
            })}
          >
            {formControl => (
              <Grid container alignItems="center">
                <Checkbox
                  name="aceiteTermosDeUso"
                  style={{ color: colors.green }}
                  checked={aceiteTermosDeUso}
                  onChange={e => {
                    formControl.setFieldValue(
                      'aceiteTermosDeUso',
                      e.target.checked,
                    )
                    if (e.target.checked) setIsOk(true)
                    else setIsOk(false)
                    setAceiteTermosDeUso(!aceiteTermosDeUso)
                  }}
                />
                <Text>
                  Li, entendi e concordo com os Termos de Uso e Termos de
                  Privacidade*
                </Text>
              </Grid>
            )}
          </Form>
        </Grid>
      </Grid>
      <Grid container>
        <Footer
          onClickBackButton={handleBackButton}
          onClickNextButton={handleSubmit}
          titleNextButton="Próximo"
          titleBackButton="Cancelar"
          isNextButtonDisabled={!isOk}
        />
      </Grid>
      <Modal
        size="large"
        showCloseButton={true}
        openModal={openModalAdBlock}
        onCloseModal={() => setOpenModalAdBlock(!openModalAdBlock)}
      >
        Para prosseguir, desative a extensão AdBlock
      </Modal>
      <ModalTermos
        openModal={openModalTermosDeUso}
        setOpenModal={handleModalTermosDeUso}
        termos={termosDeUso}
      />
      <ModalTermos
        openModal={openModalTermosDePrivacidade}
        setOpenModal={handleModalTermosDePrivacidade}
        termos={termosPrivacidade}
      />
      <SnackBar
        open={openErrorMessage}
        setOpen={setOpenErrorMessage}
        severity="error"
        message={errorMessage}
        horizontal="right"
      />
    </>
  )
}

export default DadosGerais
